/**
 * Raised when a sign-in would put a different account on a device that still
 * holds another account's writing. The sign-in screen recognizes it and opens
 * the export/removal options it points to.
 */
export class OtherAccountWritingError extends Error {
  readonly lead: string
  readonly detail = 'To sign in with a different account, use the options below: export that writing if you want to keep it, then remove it from this device.'

  /** `heldBy` names the account whose writing is here; omitted when unknown or the same name as the one signing in. */
  constructor(heldBy?: string | null) {
    const lead = heldBy
      ? `This device already holds writing from the account “${heldBy}.”`
      : 'This device already holds writing from another account.'
    super(lead)
    this.name = 'OtherAccountWritingError'
    this.lead = lead
    this.message = `${lead} ${this.detail}`
  }
}
